import { gql } from '@apollo/client';

export const GET_GEOGRAPHIES = gql`
  query GetGeographies($id: ID) {
    geography: getGeographies(id: $id) {
      id
      name
    }
  }
`;
